<template>
  <div class="w-full flex">
    <!-- Preview for form editor -->
    <div v-if="productData == null" class="w-full flex gap-1">
      <button class="flex-1 border border-trader-input-border p-1 bg-trader-blue text-white">
        Automatisch
      </button>
      <button class="flex-1 border border-trader-input-border p-1">
        Hochformat
      </button>
      <button class="flex-1 border border-trader-input-border p-1">
        Querformat
      </button>
    </div>

    <!-- Fieldtype -->
    <div v-else class=" w-full grid grid-cols-3 flex-wrap rounded overflow-hidden border border-trader-input-border bg-trader-input-border gap-[1px] dark:border-0 dark:bg-trader-darker-gray">
      <button
          class="flex-1 p-1 transition-colors"
          :class="[
          localGetFieldValue(formField.field) === ''
            ? 'bg-trader-blue text-white'
            : 'bg-white dark:bg-trader-dark-gray'
        ]"
          :disabled="readOnly"
          @click="onChangeProductFieldValue(formField.field, null, '')"
          :data-ui="'format-switch-auto'"
      >
        Automatisch
      </button>

      <button
          class="flex-1 p-1 transition-colors"
          :class="[
          localGetFieldValue(formField.field) === 'portrait'
            ? 'bg-trader-blue text-white'
            : 'bg-white dark:bg-trader-dark-gray'
        ]"
          :disabled="readOnly"
          @click="onChangeProductFieldValue(formField.field, null, 'portrait')"
          :data-ui="'format-switch-portrait'"
      >
        Hochformat
      </button>

      <button
          class="flex-1 p-1 transition-colors"
          :class="[
          localGetFieldValue(formField.field) === 'landscape'
            ? 'bg-trader-blue text-white'
            : 'bg-white dark:bg-trader-dark-gray'
        ]"
          :disabled="readOnly"
          @click="onChangeProductFieldValue(formField.field, null, 'landscape')"
          :data-ui="'format-switch-landscape'"
      >
        Querformat
      </button>
    </div>
  </div>
</template>

<script>
export default {
  meta: {
    name: "Format Switch",
    type: "fieldtype",
    version: "1.0.0",
  },
  props: {
    name: "Format Switch",
    formField: {
      type: Object,
      default: () => {}
    },
    productData: {
      type: Object,
      default: () => {}
    },
    onChangeProductFieldValue: {
      type: Function,
      default: () => {}
    },
    getFieldValue: {
      type: Function,
      default: () => {}
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    localGetFieldValue(fieldName) {
      return this.productData.customFields[fieldName]?.value || '';
    }
  }
}
</script>